import { Text as TextPdf } from '@react-pdf/renderer'

const Text = (props) => {
  let { c2 } = props
  const {
    children,
    fontSize = '7.3px',
    textAlign = 'center',
    border,
    borderContent,
    margin = '',
    minWidth,
    maxWidth,
    padding = '2px 3px',
    color = c2 ? 'rgba(0,0,0,1)' : 'rgba(30,95,160,1)',
    bold,
    style,
  } = props

  const borderStyle = {
    borderTop: border?.top || borderContent ? '1px solid rgba(30,95,160,1)' : '',
    borderRight: border?.right || borderContent ? '1px solid rgba(30,95,160,1)' : '',
    borderBottom: border?.bottom || borderContent ? '1px solid rgba(30,95,160,1)' : '',
    borderLeft: border?.left || borderContent ? '1px solid rgba(30,95,160,1)' : '',
  }

  return (
    <TextPdf
      style={{
        ...borderStyle,
        color: color,
        margin,
        minWidth: minWidth,
        maxWidth: maxWidth,
        fontSize: fontSize,
        textAlign: textAlign,
        padding: padding,
        fontFamily: bold ? 'Helvetica-Bold' : 'Helvetica',
        ...style,
      }}
    >
      {children !== 'null' ? children : '-'}
    </TextPdf>
  )
}

export default Text
